import http from "../http/http-config";
import { BuildingSurfaceLimit } from "../models/buildingSurfaceLimit";

export default new class houseTypeService {
    getBuildingSurfaceLimits(): Promise<BuildingSurfaceLimit[]> {
        return http.get<BuildingSurfaceLimit[]>("GetBuildingSurface", {
            params: {
            }
        }).then(response => response.data)
    }
}